/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAccessLimitResponse } from './UserAccessLimitResponse';
import {
    UserAccessLimitResponseFromJSON,
    UserAccessLimitResponseFromJSONTyped,
    UserAccessLimitResponseToJSON,
    UserAccessLimitResponseToJSONTyped,
} from './UserAccessLimitResponse';

/**
 * 
 * @export
 * @interface UserAccessLimitsResponse
 */
export interface UserAccessLimitsResponse {
    /**
     * 
     * @type {UserAccessLimitResponse}
     * @memberof UserAccessLimitsResponse
     */
    activeTournaments: UserAccessLimitResponse;
    /**
     * 
     * @type {UserAccessLimitResponse}
     * @memberof UserAccessLimitsResponse
     */
    activeLeagues: UserAccessLimitResponse;
    /**
     * 
     * @type {UserAccessLimitResponse}
     * @memberof UserAccessLimitsResponse
     */
    activeTrainings: UserAccessLimitResponse;
    /**
     * 
     * @type {UserAccessLimitResponse}
     * @memberof UserAccessLimitsResponse
     */
    managedTeams: UserAccessLimitResponse;
}

/**
 * Check if a given object implements the UserAccessLimitsResponse interface.
 */
export function instanceOfUserAccessLimitsResponse(value: object): value is UserAccessLimitsResponse {
    if (!('activeTournaments' in value) || value['activeTournaments'] === undefined) return false;
    if (!('activeLeagues' in value) || value['activeLeagues'] === undefined) return false;
    if (!('activeTrainings' in value) || value['activeTrainings'] === undefined) return false;
    if (!('managedTeams' in value) || value['managedTeams'] === undefined) return false;
    return true;
}

export function UserAccessLimitsResponseFromJSON(json: any): UserAccessLimitsResponse {
    return UserAccessLimitsResponseFromJSONTyped(json, false);
}

export function UserAccessLimitsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessLimitsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'activeTournaments': UserAccessLimitResponseFromJSON(json['activeTournaments']),
        'activeLeagues': UserAccessLimitResponseFromJSON(json['activeLeagues']),
        'activeTrainings': UserAccessLimitResponseFromJSON(json['activeTrainings']),
        'managedTeams': UserAccessLimitResponseFromJSON(json['managedTeams']),
    };
}

export function UserAccessLimitsResponseToJSON(json: any): UserAccessLimitsResponse {
    return UserAccessLimitsResponseToJSONTyped(json, false);
}

export function UserAccessLimitsResponseToJSONTyped(value?: UserAccessLimitsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeTournaments': UserAccessLimitResponseToJSON(value['activeTournaments']),
        'activeLeagues': UserAccessLimitResponseToJSON(value['activeLeagues']),
        'activeTrainings': UserAccessLimitResponseToJSON(value['activeTrainings']),
        'managedTeams': UserAccessLimitResponseToJSON(value['managedTeams']),
    };
}

